import React from "react";
import PropTypes from "prop-types";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';
import "./styles.css";

registerLocale('pt-BR', ptBR);

const DateSelector = ({
  defineMinDateFromNow,
  defineMaxDateFromNow,
  disabled,
  initialValue,
  label,
  notClearable,
  onChange,
  placeholder,
  selected,
  value
}) => {
   if (typeof selected === 'string') {
     selected = new Date(selected);
   }

   return (
      <>
         <span>{label && label}</span>
         <DatePicker
            locale="pt-BR"
            dateFormat="dd/MM/yyyy"
            selected={selected}
            onChange={onChange}
            value={value}
            placeholderText={placeholder || "Selecione uma data"}
            disabled={disabled}
            isClearable={!notClearable}
            minDate={
              (!!defineMinDateFromNow)
              ? addDays(initialValue, defineMinDateFromNow)
              : null
            }
            maxDate={
               (!!defineMaxDateFromNow)
               ? new Date(defineMaxDateFromNow)
               : null
             }
         />
      </>
   );
};

DateSelector.propTypes = {
  defineMinDateFromNow: PropTypes.number,
};

export default DateSelector;
